import { IControl } from './control.interface';
import { IListColumn } from './list-column/list-column.interface';
import { TStringBool } from './tstring-bool.type';

/** FE should send on BE side selected items ids for 'selectable' list under this key */
export const SELECTED_ITEMS_KEY = 'selected';

export interface IList extends IControl {
  /** List id */
  $key: string;
  /**
   * List type
   * - `block` renders the list as the list of blocks
   * - `table` renders the list as the table (w/ table header).
   * - `selectable` renders the list as separate selectable rows
   * Column names should be picked up with `list_` prefix.
   */
  $type?: 'block' | 'selectable' | 'table';
  /** Row size type */
  $row_type?: 'large' | 'medium' | 'separated' | 'small';
  /** Columns descriptions */
  col: IListColumn[];
  /** In block type define how many cards will be in row */
  $blocks_in_row?: string;
  /** Should table displayed with hover effect */
  $hover?: TStringBool;
  /** Should table rows displayed with bottom border underlining */
  $underline?: TStringBool;
  /** Should list collapse */
  $collapsible?: TStringBool;
  /** Minimal width for list */
  $minwidth?: string;
  /** Maximum width for list */
  $maxwidth?: string;
  /** Amount of items to show */
  $display_limit?: string;
}
